export default __webpack_public_path__ + "static/media/gallery_03.97fee5f8.jpg";